
import { defineComponent, PropType } from 'vue'

const COLORS = {
  default: '',
  success: 'juniper',
  warning: 'honey',
  info: 'aqua',
  danger: 'cherry'
}

const SIZES = {
  sm: 'w-2 h-2',
  md: 'w-2.5 h-2.5',
  lg: 'w-3 h-3'
}

export default defineComponent({
  name: 'ZBadge',
  components: {},
  props: {
    value: [String, Number],
    max: Number,
    isDot: Boolean,
    hidden: Boolean,
    size: {
      type: String as PropType<keyof typeof SIZES>,
      default: 'sm',
      validator(val: string) {
        return ['sm', 'md', 'lg'].includes(val)
      }
    },
    type: {
      type: String as PropType<keyof typeof COLORS>,
      default: 'default',
      validator(val: string) {
        return ['default', 'success', 'warning', 'info', 'danger'].includes(val)
      }
    },
    position: {
      type: String
    },
    textColor: {
      type: String,
      default: 'vanilla-100'
    },
    isNotification: {
      type: Boolean
    }
  },
  computed: {
    bgColor(): string {
      return `bg-${COLORS[this.type]}`
    },
    notificationClasses(): string {
      return 'relative top-0 right-0 translate-x-0 translate-y-0'
    },
    typeClasses(): string {
      if (typeof this.value === 'number') {
        return 'h-6 w-6 flex justify-center items-center text-xxs font-bold'
      }
      return 'inline-block text-xs px-2'
    },
    sizeClasses(): string {
      return this.isDot ? SIZES[this.size] : ''
    },
    positionClasses(): string {
      if (this.position) {
        return this.position
      } else {
        if (this.value) {
          return 'top-px right-0'
        }
        if (this.isDot) {
          return 'top-px right-px'
        }
        return 'top-0'
      }
    },
    content(): string | number | null {
      if (this.isDot) {
        return null
      }
      if (typeof this.value === 'number' && typeof this.max === 'number') {
        return this.max < this.value ? `${this.max}+` : this.value
      }
      return this.value ?? null
    }
  }
})
